import { render, staticRenderFns } from "./UserRepliesPosts.vue?vue&type=template&id=7ad2f04a&scoped=true&"
import script from "./UserRepliesPosts.vue?vue&type=script&lang=js&"
export * from "./UserRepliesPosts.vue?vue&type=script&lang=js&"
import style0 from "./UserRepliesPosts.vue?vue&type=style&index=0&id=7ad2f04a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad2f04a",
  null
  
)

export default component.exports